var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilingBannerDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9.25C12.6635 5.83652 10.2459 4.47863e-07 5.41852 2.36851e-07C2.42596 1.06042e-07 -1.06042e-07 2.42596 -2.36851e-07 5.41852C-4.47863e-07 10.2459 5.83652 12.6635 9.25 9.25Z",
    fill: "#FACC81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 27.75C12.6635 24.3365 10.2459 18.5 5.41852 18.5C2.42596 18.5 -1.06042e-07 20.926 -2.36851e-07 23.9185C-4.47863e-07 28.7459 5.83652 31.1635 9.25 27.75Z",
    fill: "#FACC81"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 27.75C31.1635 24.3365 28.7459 18.5 23.9185 18.5C20.926 18.5 18.5 20.926 18.5 23.9185C18.5 28.7459 24.3365 31.1635 27.75 27.75Z",
    fill: "#FACC81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 9.25C31.1635 5.83652 28.7459 4.47863e-07 23.9185 2.36851e-07C20.926 1.06042e-07 18.5 2.42596 18.5 5.41852C18.5 10.2459 24.3365 12.6635 27.75 9.25Z",
    fill: "#FACC81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilingBannerDots);
export default __webpack_public_path__ + "static/media/profiling-banner-dots.eecac1a6180d58fcc354b18a7bbe7a0f.svg";
export { ForwardRef as ReactComponent };